import React from "react";

export const adminPagesConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/patients",
        component: React.lazy(() => import("./Patients")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/practitioners",
        component: React.lazy(() => import("./Practitioners")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/users",
        component: React.lazy(() => import("./Users")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/practitioner-approval",
        component: React.lazy(() => import("./ClinicianApproval")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/practitioner-approval/practitioner-details",
        component: React.lazy(() => import("./ClinicianApproval/AppDetails")),
      },
    ],
  },

  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/templates",
        component: React.lazy(() => import("./TemplatesList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/templates/builder",
        component: React.lazy(() => import("./TemplateCreation")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/blogs",
        component: React.lazy(() => import("./BlogsCreation/BlogsList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/blogs/builder",
        component: React.lazy(() => import("./BlogsCreation")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/templates/viewBuilder",
        component: React.lazy(() => import("./ViewTemplate")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/roles-permision",
        component: React.lazy(() => import("./RolesPermissionList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/price-settings",
        component: React.lazy(() => import("./PriceSettings")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/roles-permision/add",
        component: React.lazy(() => import("./AddRolesPermission")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/notifications-communication",
        component: React.lazy(() => import("./Notifications")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/tasks-communication",
        component: React.lazy(() => import("./Tasks")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/questionnaires",
        component: React.lazy(
          () => import("./QuestionnaireBuilder/QuestionnaireList")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/questionnaires/builder",
        component: React.lazy(() => import("./QuestionnaireBuilder")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/questionnaires/:questionnaires_id/assign",
        component: React.lazy(
          () => import("./QuestionnaireBuilder/QuestionnaireAssign")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/faqs",
        component: React.lazy(() => import("./FAQBuilder/FaqList")),
      },
    ],
  },

  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/faqs/builder",
        component: React.lazy(() => import("./FAQBuilder")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-practitioners",
        component: React.lazy(() => import("./Practitioners")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-patients",
        component: React.lazy(() => import("./Patients")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-linkedUsers",
        component: React.lazy(() => import("./LinkedUsers")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/user-management-linkedUsers/add",
        component: React.lazy(() => import("./AddLinkedUsers")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-user",
        component: React.lazy(() => import("./Users")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/user-management-user/add",
        component: React.lazy(() => import("./AddUsers")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-organisations",
        component: React.lazy(() => import("./Organizations")),
      },
    ],
  },
  // {
  //   auth: ['user'],
  //   routes: [
  //     {
  //       exact: false,
  //       path: '/user-management-organisations/add-edit',
  //       component: React.lazy(() => import('./AddOrganization')),
  //     },
  //   ],
  // },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-organisationUsers",
        component: React.lazy(() => import("./OrganizationUsers")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/user-management-adminUsers",
        component: React.lazy(() => import("./AdminUsers")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: false,
        path: "/user-management-adminUsers/add-edit",
        component: React.lazy(() => import("./AddAdminUsers")),
      },
    ],
  },

  {
    auth: ["user"],
    routes: [
      {
        path: "/website-communication",
        component: React.lazy(
          () => import("./Communications/WebsiteCommunications")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/patient-communication",
        component: React.lazy(
          () => import("./Communications/PatientCommunication")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/admin-communication",
        component: React.lazy(
          () => import("./Communications/AdminCommunication")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/cancellation-reason",
        component: React.lazy(
          () => import("./Communications/CancellationReason/index")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/manage-document-type",
        component: React.lazy(
          () => import("./SiteSetting/ManageDocumentType")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/manage-appointment-type",
        component: React.lazy(
          () => import("./SiteSetting/ManageAppointmentType")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/manage-appointment-group-type",
        component: React.lazy(
          () => import("./SiteSetting/ManageAppointmentGroupType")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/task",
        component: React.lazy(() => import("./Communications/Task/TasksPage")),
      },
      {
        path: "/task-bin",
        component: React.lazy(() => import("./Communications/Task/TaskBin")),
      },
      {
        path: "/task-create-patient",
        component: React.lazy(
          () => import("./Communications/Task/CreatePatientTask")
        ),
      },
      {
        path: "/task-create-practitioner",
        component: React.lazy(
          () => import("./Communications/Task/CreatePractitionerTask")
        ),
      },
      {
        path: "/task-create-admin",
        component: React.lazy(
          () =>
            import("./Communications/Task/CreateAdminTask")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/practitioner-communication",
        component: React.lazy(
          () => import("./Communications/PractitionerCommunication")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/organisation-communication",
        component: React.lazy(
          () => import("./Communications/OrganisationCommunication")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/feedback-communication",
        component: React.lazy(
          () => import("./Communications/FeedbackCommunications")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/complaint-status",
        component: React.lazy(
          () =>
            import("./Communications/FeedbackCommunications/ComplaintStatus")
        ),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/pharma-zone",
        component: React.lazy(() => import("./VendorSettings")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/patient-invoices",
        component: React.lazy(() => import("./Billing/PatientInvoice")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        exact: true,
        path: "/practitioner-statements",
        component: React.lazy(() => import("./Billing/PractitionerStatements")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/patient-pending-payments",
        component: React.lazy(() => import("./Billing/PatientPendingPayments")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/vrevised",
        component: React.lazy(() => import("./VRevised")),
      },
    ],
  },
];